import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components

import BlockWrapper from './BlockWrapper';


// ActionCreators

import { changeData } from '../../../actions/ssap/ssapActionCreators';


// Utils

import { bitWiseOperatorTools } from '../../../utils/tools/bitWiseOperatorTools';
import { normalizeNameOfPerson } from '../../../utils/normalize/normalizeNameOfPerson';
import { normalizeStringToBooleanValue } from '../../../utils/normalize/normalizeStringToBooleanValue';

// Constants

import { MASKS } from '../../../constants/ssap/masks/masksConstants';



const FlagsTooltip = props => {
    const {
        data,
        householdMembers,
        id
    } = props;

    const [ state, setState ] = useState(householdMembers.reduce((state, hhm, idx) => ({ ...state, [idx]: false }), {}));

    const getMasksVisibility = householdMembers => householdMembers.map(() => {
        return Object.keys(MASKS).reduce((state, maskType) => ({ ...state, [maskType]: true }), {});
    });

    const [ masksVisibility, toggleMasksVisibility] = useState(getMasksVisibility(householdMembers));

    useEffect(() => {
        toggleMasksVisibility(getMasksVisibility(householdMembers));
    }, [ householdMembers.length ]);

    const updateTaxHouseholdCompositionFlags = (...args) => {
        const [ type, newState, hhmIndex, updatedFlags ] = args;
        const _thc = payload => {
            const convert = (...payload) => {
                return bitWiseOperatorTools.convertFlagsToValues.apply(this, payload);
            };
            return convert.apply(this, [payload, MASKS[type]]);
        };

        newState
            .taxHousehold
            .householdMember[hhmIndex]
            .taxHouseholdComposition = {
                ...newState
                    .taxHousehold
                    .householdMember[hhmIndex]
                    .taxHouseholdComposition,
                ..._thc(updatedFlags)
            };
    };

    const handleMasksClick = (type, hhmIndex) => {
        const newState = { ...data };

        const newValues = prompt('Enter new value');

        if(newValues === null) {
            return null;
        }

        const updatedFlags = bitWiseOperatorTools
            .setInitialValue(
                MASKS[type],
                newValues
                    .split(',')
                    .map(v => normalizeStringToBooleanValue(v))
            );

        if(type === 'taxHouseholdComposition') {
            updateTaxHouseholdCompositionFlags(type, newState, hhmIndex, updatedFlags);
        }

        newState
            .taxHousehold
            .householdMember[hhmIndex]
            .flagBucket[`${type}Flags`] = updatedFlags;


        props.actions.changeData(newState);
    };

    const handleFlagClick = (type, name, hhmIndex) => {

        const newState = { ...data };

        const updatedFlags = bitWiseOperatorTools
            .getUpdatedFlags(
                householdMembers[hhmIndex].flagBucket[`${type}Flags`],
                [[MASKS[type][name], (v => normalizeStringToBooleanValue(v))(prompt('Enter new value'))]]
            );

        if(type === 'taxHouseholdComposition') {
            updateTaxHouseholdCompositionFlags(type, newState, hhmIndex, updatedFlags);
        }

        newState
            .taxHousehold
            .householdMember[hhmIndex]
            .flagBucket[`${type}Flags`] = updatedFlags;

        props.actions.changeData(newState);
    };

    const handleMemberToggle = idx => {
        setState(state => ({
            ...state,
            [idx]: !state[idx]
        }));
    };

    const handleMasksGroupToggle = (maskType, idx) => {
        toggleMasksVisibility(state => state.map((hhm, i) => i !== idx ? hhm : { ...hhm, [maskType]: !hhm[maskType] }));
    };

    const handleMouseOver = (e, color = undefined) => {
        e.currentTarget.style.backgroundColor = color ? color : 'yellow';
    };

    const handleMouseLeave = (e, color = undefined) => {
        e.currentTarget.style.backgroundColor = color ? color : 'initial';
    };

    return (
        <BlockWrapper id={id}>
            <div>
                <div style={{ fontSize: '1.5rem' }}>
                    Flags current status
                </div>
                {
                    householdMembers.map((hhm, idx) => {
                        const {
                            flagBucket,
                            name,
                        } = hhm;

                        return (
                            <div
                                key={`${name}_${idx}`}
                            >
                                <div style={{  margin: '10px 0' }}>
                                    <span style={{ color: 'yellow', cursor: 'pointer', fontSize: '1.3rem' }} onClick={() => handleMemberToggle(idx)}>{normalizeNameOfPerson(name)}</span>
                                </div>
                                {
                                    Object.entries(MASKS).map(([ maskType, masks ]) => {
                                        const flagsName = `${maskType}Flags`;
                                        return (
                                            <div
                                                key={maskType}
                                                style={{ display: state[idx] ? 'block' : 'none' }}
                                            >
                                                <div
                                                    style={{
                                                        display: 'inline-block',
                                                        marginRight: '10px',
                                                        cursor: 'pointer',
                                                        color: masksVisibility[idx] && masksVisibility[idx][maskType] ? 'red' : 'lightgreen',
                                                        fontSize: '1.2rem'
                                                    }}
                                                    onClick={() => handleMasksGroupToggle(maskType, idx)}
                                                >
                                                    [ { masksVisibility[idx] && masksVisibility[idx][maskType] ? 'x' : 'v' } ]
                                                </div>
                                                <span
                                                    style={{
                                                        color: 'orange',
                                                        padding: '5px 0',
                                                        fontSize: '1.2rem',
                                                    }}
                                                    onClick={() => handleMasksClick(maskType, idx)}
                                                >
                                                    {
                                                        maskType
                                                    }
                                                    : flags = &nbsp;
                                                    {
                                                        <span style={{ cursor: 'pointer' }}>{ flagBucket && flagBucket[flagsName] || 'No flags' } </span>
                                                    }
                                                </span>
                                                {
                                                    Object.entries(masks).map(indicator => {
                                                        const [ name, masks  ] = indicator;
                                                        const flags = flagBucket && flagBucket[flagsName] || 0;
                                                        return (
                                                            <div key={indicator}
                                                                style={{
                                                                    position: 'relative' ,
                                                                    display: masksVisibility[idx] && masksVisibility[idx][maskType] ? 'block' : 'none'
                                                                }}
                                                                onMouseOver={e => handleMouseOver(e, 'yellow')}
                                                                onMouseLeave={e => handleMouseLeave(e)}
                                                            >
                                                                <span style={{ fontSize: '1.2rem' }}>
                                                                    { name.split('Flags')[0] }
                                                                </span>
                                                                <span
                                                                    style={{
                                                                        fontSize: '1.0rem',
                                                                        position: 'absolute',
                                                                        left: '200px',
                                                                        cursor: 'pointer',
                                                                        paddingTop: '5px'
                                                                    }}
                                                                    onClick={() => handleFlagClick(maskType, name, idx)}
                                                                >
                                                                    {
                                                                        (v => String(v !== undefined ? v : 'not got').toLocaleUpperCase()
                                                                        )(bitWiseOperatorTools.getFlagValue(flags)(masks))
                                                                    }
                                                                </span>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        );
                    })

                }
            </div>
        </BlockWrapper>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data,

    householdMembers: state
        .ssap
        .data
        .taxHousehold
        .householdMember
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FlagsTooltip);